module.exports = __webpack_public_path__ + "media/images/number_2_green-7c15c9df17ae702b2ba16246c77b00e0.png";